import { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { format, addDays } from "date-fns";
import Select from "react-select";
import { config, encodeBase64RequestBody, numberFormat, priceFormat, shortenUrl } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const QuotationAtbDetail = () => {
  const { id_quotation, term_number } = useParams();
  const [quotation, setQuotation] = useState(null);
  const [quotationItems, setQuotationItems] = useState([]);
  const [quotationItemList, setQuotationItemList] = useState([]);
  const [quotationAttachmentList, setQuotationAttachmentList] = useState([]);
  const [quotationPaymentRate, setQuotationPaymentRate] = useState(100);
  const [salesOrder, setSalesOrder] = useState(null);
  const [iouList, setIouList] = useState(null);
  const [currency, setCurrency] = useState('IDR');
  const [exchangeRate, setExchangeRate] = useState(0);
  const [subcompanyList, setSubcompanyList] = useState(null);
  const [subcompanyId, setSubcompanyId] = useState(null);
  const [isEditable, setIsEditable] = useState(true);
  const [isEditing, setIsEditing] = useState(true);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const navigate = useNavigate();

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    getQuotation();
  }, []);

  useEffect(() => {
    if (quotation) {
      getSubcompanyList();
    }
  }, [quotation]);

  useEffect(() => {
    if (iouList) {
      getSalesOrder();
    }
  }, [iouList]);

  useEffect(() => {
    if (subcompanyList) {
      getIouList();
    }
  }, [subcompanyList]);

  useEffect(() => {
    if (iouList && quotation && exchangeRate) {
      const updatedIouList = [...iouList];
      const mutableQuotationItemList = [...quotation.quotation_item_list];

      for (let iouIndex in updatedIouList) {
        let iouSubtotal = 0;
        for (let iouItemIndex in updatedIouList[iouIndex].iou_items) {
          let iouItem = updatedIouList[iouIndex].iou_items[iouItemIndex];
          let quotationItemIndex = mutableQuotationItemList.findIndex(item => parseInt(item.product_id) === parseInt(iouItem.product_id) && !item.is_taken);

          let quotationItem;
          if (quotationItemIndex !== -1) {
            mutableQuotationItemList[quotationItemIndex].is_taken = true;
            quotationItem = mutableQuotationItemList[quotationItemIndex];
          } else {
            quotationItem = quotation.quotation_items.find(item => item.product_display_name === iouItem.product_display_name);
          }

          if (quotationItem) {
            iouItem.product_cost_original = quotationItem.product_cost_original ? parseFloat(quotationItem.product_cost_original) : 0;
            iouItem.product_price_original = quotationItem.product_price_original ? parseFloat(quotationItem.product_price_original) : 0;
            iouItem.product_cost = iouItem.product_currency_original !== currency ? (quotationItem.product_cost_original * exchangeRate) : parseFloat(quotationItem.product_cost);
            iouItem.product_price = iouItem.product_currency_original !== currency ? (quotationItem.product_price_original * exchangeRate) : parseFloat(quotationItem.product_price);
            iouItem.product_subtotal = parseFloat((iouItem.product_price * iouItem.product_qty * iouItem.contract_long_period).toFixed(3));
            iouItem.product_prorate = parseFloat((iouItem.product_qty / parseFloat(quotationItem.product_qty) * 100).toFixed(3));
            iouItem.product_discount_price = parseFloat(((quotationItem.product_discount_price * iouItem.product_prorate / 100) * (iouItem.contract_long_period / quotationItem.contract_long_period)).toFixed(3));
            iouItem.product_discount_rate = parseFloat((iouItem.product_discount_price / parseFloat(quotationItem.product_subtotal) * 100).toFixed(3));
            iouItem.product_total = parseFloat((iouItem.product_subtotal - iouItem.product_discount_price).toFixed(3));
            iouItem.product_total_prorate = iouItem.product_total / parseFloat(quotation.quotation_subtotal) * 100;
            iouItem.product_discount_prorate = parseFloat((iouItem.product_total_prorate * quotation.quotation_discount_price / 100).toFixed(3));
            iouItem.product_grand_total = parseFloat(((iouItem.product_total - iouItem.product_discount_prorate) * quotationPaymentRate / 100).toFixed(3));
            iouItem.product_margin_price = parseFloat((iouItem.product_grand_total - (iouItem.product_cost * iouItem.product_qty * iouItem.contract_long_period * quotationPaymentRate / 100)).toFixed(3));
            iouItem.product_margin_rate = iouItem.product_grand_total > 0 ? parseFloat((iouItem.product_margin_price / iouItem.product_grand_total * 100).toFixed(3)) : 0;

            iouSubtotal += parseFloat((iouItem.product_grand_total).toFixed(3));
          }
        }
        updatedIouList[iouIndex].iou_exchange_rate = exchangeRate;
        updatedIouList[iouIndex].iou_subtotal = iouSubtotal;
        updatedIouList[iouIndex].iou_total = iouSubtotal;
        updatedIouList[iouIndex].iou_tax_price = parseFloat((iouSubtotal * 12 / 100).toFixed(3));
        updatedIouList[iouIndex].iou_grand_total = parseFloat((iouSubtotal + updatedIouList[iouIndex].iou_tax_price).toFixed(3));
      }
      if (JSON.stringify(updatedIouList) !== JSON.stringify(iouList)) {
        setIouList(updatedIouList);
      }
    }
  }, [quotation, iouList, exchangeRate]);

  const getQuotation = async () => {
    try {
      const fetchGetQuotation = await jwtFetch(config.ENDPOINT + 'get/quotation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_quotation: id_quotation
        })
      });
      let responseGetQuotation = await fetchGetQuotation.json();
      if (responseGetQuotation.data) {
        if (responseGetQuotation.data[0].attachment_files) {
          let attachmentFiles = JSON.parse(responseGetQuotation.data[0].attachment_files);
          for (let a in attachmentFiles) {
            attachmentFiles[a].status = 'Ada & Terlampir';
          }
          setQuotationAttachmentList([...quotationAttachmentList, ...attachmentFiles]);
        }

        if (responseGetQuotation.data[0].quotation_items) {
          let itemList = responseGetQuotation.data[0].quotation_items;
          for (let i in itemList) {
            if (itemList[i].billing_payment_period === 'Custom') {
              for (let p in itemList[i].payment_simulations) {
                if (itemList[i].payment_simulations[p].term_number === term_number) {
                  setQuotationPaymentRate(parseFloat(itemList[i].payment_simulations[p].payment_rate));
                }
              }
            }
          }
        }

        setQuotationItems([...quotationItems, ...responseGetQuotation.data[0].quotation_items]);
        setQuotationItemList([...quotationItemList, ...responseGetQuotation.data[0].quotation_item_list]);
        setQuotation(responseGetQuotation.data[0]);
      } else {
        alert(responseGetQuotation.message);
      }
    } catch (error) {
      console.error('Error in getQuotation:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getSalesOrder = async () => {
    try {
      const fetchGetSalesOrder = await jwtFetch(config.ENDPOINT + 'get/so', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_so: iouList[0].so_id
        })
      });
      const responseGetSalesOrder = await fetchGetSalesOrder.json();
      if (responseGetSalesOrder.data) {
        setSalesOrder(responseGetSalesOrder.data[0]);
      } else {
        alert(responseGetSalesOrder.message);
      }
    } catch (error) {
      console.error('Error in getSalesOrder:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getIouList = async () => {
    try {
      const requestIouList = {
        quotation_id: id_quotation,
        term_number: term_number
      }
      const fetchIouList = await jwtFetch(config.ENDPOINT + 'get/iou', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestIouList)
      });
      const responseIouList = await fetchIouList.json();
      if (responseIouList.status === 200) {
        let total = 0;
        let ious = [];
        for (let i in responseIouList.data) {
          let iou = responseIouList.data[i];
          const subcompany = subcompanyList.find(sub => sub.id_subcompany === iou.subcompany_id);
          iou.action = 'Update';
          iou.subcompany = subcompany;
          iou.iou_tax_rate = parseFloat(iou.iou_tax_rate);
          iou.iou_tax_price = 0;
          iou.request_invoice_pillar = iou.request_invoice_pillar || 'Non-Bundling';
          iou.request_invoice_type = iou.request_invoice_type || 'New Order';
          iou.request_invoice_company_name = iou.request_invoice_company_name || iou.subcompany_name;
          iou.request_invoice_company_address = iou.request_invoice_company_address || iou.subcompany_address;
          iou.request_invoice_company_phone = iou.request_invoice_company_phone || iou.subcompany_phone;
          total += iou.iou_grand_total;
          iou.iou_items = await getIouItemList(responseIouList.data[i].id_iou);
          if (iou.iou_status === 'New') {
            iou.request_invoice_documents = ['Invoice', 'Faktur Pajak', 'Receipt/Kwitansi'];
            iou.request_invoice_attachments = [...quotationAttachmentList];
          } else {
            iou.request_invoice_documents = JSON.parse(iou.request_invoice_documents) || [];
            iou.request_invoice_attachments = JSON.parse(iou.request_invoice_attachments) || [];
          }
          ious.push(iou);
          if (iou.iou_status === 'Notification Sent') {
            setIsEditable(false);
            setIsEditing(false);
          }
        }
        setIouList(ious);
        setCurrency(responseIouList.data[0].iou_currency);
        setExchangeRate(parseFloat(responseIouList.data[0].iou_exchange_rate));
      } else {
        alert(responseIouList.message);
      }
    } catch (error) {
      console.error('Error in getIouList:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getIouItemList = async (iou_id) => {
    try {
      const requestIouItemList = {
        iou_id: iou_id
      }
      const fetchIouItemList = await jwtFetch(config.ENDPOINT + 'get/iou_item', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestIouItemList)
      });
      const responseIouItemList = await fetchIouItemList.json();
      if (responseIouItemList.status === 200) {
        let iouItems = [];
        for (let i in responseIouItemList.data) {
          if (responseIouItemList.data[i].product_qty > 0) {
            let iouItem = responseIouItemList.data[i];
            iouItem.action = 'Update';
            iouItems.push(iouItem);
          }
        }
        return iouItems;
      } else {
        alert(responseIouItemList.message);
      }
    } catch (error) {
      console.error('Error in getIouItemList:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getSubcompanyList = async () => {
    try {
      const requestSubcompanyList = {
        company_id: quotation.company_id
      }
      const fetchSubcompanyList = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestSubcompanyList)
      });
      const responseSubcompanyList = await fetchSubcompanyList.json();
      if (responseSubcompanyList.status === 200) {
        setSubcompanyList(responseSubcompanyList.data);
      } else {
        alert(responseSubcompanyList.message);
      }
    } catch (error) {
      console.error('Error in getSubcompanyList:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const changeIouData = (iouIndex, column, value) => {
    let iou = iouList[iouIndex];
    iou[column] = value;
    setIouList([...iouList]);
  }

  const changeIouItemProduct = (iouIndex, iouItemIndex, productId) => {
    let iouItem = iouList[iouIndex].iou_items[iouItemIndex];
    let quotationItem;
    const itemIndex = quotationItemList.findIndex(product => product.product_id === parseInt(productId) && !product.is_taken);

    if (itemIndex !== -1) {
      const newQuotationItemList = [...quotationItemList];
      newQuotationItemList[itemIndex] = { ...newQuotationItemList[itemIndex], is_taken: true };
      setQuotationItemList(newQuotationItemList);
      quotationItem = newQuotationItemList[itemIndex];
    } else {
      quotationItem = quotationItems.find(product => product.product_display_name === productId);
    }

    iouItem.product = quotationItem;
    iouItem.product_id = quotationItem.product_id;
    iouItem.product_display_name = quotationItem.product_display_name;
    iouItem.product_display_description = quotationItem.product_display_description;
    iouItem.product_type = quotationItem.product_type;
    iouItem.product_domain = quotationItem.product_domain;
    iouItem.product_qty = 0;
    iouItem.service_type = quotationItem.service_type;
    // iouItem.contract_long_period = iouList[0].number_of_months;
    iouItem.contract_long_period = quotationItem.contract_long_period;
    iouItem.contract_duration_period = quotationItem.contract_duration_period;
    iouItem.product_active_licence_date = quotationItem.product_type === 'Bundle' ? salesOrder.so_billing_date : quotationItem.product_active_licence_date;
    iouItem.product_currency_original = quotationItem.product_currency_original;
    iouItem.product_currency = quotationItem.product_currency;
    setIouList([...iouList]);
  }

  const changeIouItemQty = (iouIndex, iouItemIndex, qty) => {
    let iou = iouList[iouIndex];
    let iouItem = iou.iou_items[iouItemIndex];
    iouItem.product_qty = parseInt(qty);
    setIouList([...iouList]);
  }

  const addIouItemProduct = (iouIndex) => {
    const iou = iouList[iouIndex];
    const iouItem = {
      "iou_id": iou.id_iou,
      "product": null,
      "product_id": '',
      "product_display_name": '',
      "product_display_description": '',
      "product_type": '',
      "product_domain": '',
      "product_qty": 0,
      "product_prorate": 0,
      "product_currency_original": '',
      "product_currency": '',
      "product_cost_original": 0,
      "product_cost": 0,
      "product_price_original": 0,
      "product_price": 0,
      "product_subtotal": 0,
      "product_discount_rate": 0,
      "product_discount_price": 0,
      "product_discount_prorate": 0,
      "product_total": 0,
      "product_total_prorate": 0,
      "product_grand_total": 0,
      "product_active_licence_date": '',
      "service_type": '',
      "contract_long_period": 0,
      "contract_duration_period": '',
      "action": 'Create'
    }
    iou.iou_items.push(iouItem);
    setIouList([...iouList]);
  }

  const removeIouItemProduct = (iouIndex, iouItemIndex) => {
    const iouItems = iouList[iouIndex].iou_items;
    iouItems.splice(iouItemIndex, 1);
    setIouList([...iouList]);
  }

  const addIou = () => {
    const subcompany = subcompanyList.find(sub => sub.id_subcompany === subcompanyId.value);
    const ious = iouList;
    const newIou = {
      "id_iou": '0',
      "quotation_id": ious[0].quotation_id,
      "so_id": ious[0].so_id,
      "company_id": ious[0].company_id,
      "subcompany": subcompany,
      "subcompany_id": subcompanyId.value,
      "subcompany_name": subcompanyId.label,
      "term_number": term_number,
      "number_of_months": ious[0].number_of_months,
      "iou_year": ious[0].iou_year,
      "iou_currency": ious[0].iou_currency,
      "iou_exchange_rate": ious[0].iou_exchange_rate,
      "iou_tax_price": 0,
      "iou_tax_rate": ious[0].iou_tax_rate,
      "iou_items": [],
      "iou_subtotal": 0,
      "iou_total": 0,
      "iou_grand_total": 0,
      "iou_status": "New",
      "start_term_period": ious[0].start_term_period,
      "end_term_period": ious[0].end_term_period,
      "request_invoice_by": null,
      "request_invoice_date": null,
      "request_invoice_pillar": 'Non-Bundling',
      "request_invoice_type": 'New Order',
      "request_invoice_documents": ['Invoice', 'Faktur Pajak', 'Receipt/Kwitansi'],
      "request_invoice_company_name": subcompany.company_name,
      "request_invoice_company_address": subcompany.company_address,
      "request_invoice_company_npwp": '',
      "request_invoice_company_phone": subcompany.company_phone,
      "request_invoice_company_fax": '',
      "request_invoice_contact_name": '',
      "request_invoice_contact_position": '',
      "request_invoice_attachments": quotationAttachmentList ? [...quotationAttachmentList] : [],
      "request_invoice_delivery": '',
      "request_invoice_remarks": '',
      "sales_name": ious[0].sales_name,
      "created_on": ious[0].created_on,
      "created_by": ious[0].created_by,
      "action": 'Create'
    }
    ious.push(newIou);
    setIouList([...iouList]);
    setSubcompanyId(null);
  }

  const removeIou = (iouIndex) => {
    const ious = iouList;
    ious.splice(iouIndex, 1);
    setIouList([...iouList]);
  }

  const validateQuantities = () => {
    const quotationQuantities = new Map();
    const iouQuantities = new Map();

    quotationItemList.forEach(item => {
      const currentQty = quotationQuantities.get(item.product_display_name) || 0;
      quotationQuantities.set(item.product_display_name, currentQty + item.product_qty);
    });

    iouList.forEach(iou => {
      iou.iou_items.forEach(item => {
        const currentQty = iouQuantities.get(item.product_display_name) || 0;
        iouQuantities.set(item.product_display_name, currentQty + item.product_qty);
      });
    });

    let isValid = {
      "status": true,
      "iou_index": "",
      "iou_item_index": "",
    };

    quotationQuantities.forEach((quotationQty, product_display_name) => {
      const iouQty = iouQuantities.get(product_display_name) || 0;
      if (quotationQty !== iouQty) {
        isValid.status = false;
        isValid.message = "Total quantity of " + product_display_name + " must be " + quotationQty + '.';
      }
    });

    return isValid;
  };

  const addIouDocument = (iouIndex) => {
    let iou = iouList[iouIndex];
    iou.request_invoice_documents = [...iou.request_invoice_documents, ''];
    setIouList([...iouList]);
  }

  const removeIouDocument = (iouIndex, documentIndex) => {
    const iou = iouList[iouIndex];
    iou.request_invoice_documents.splice(documentIndex, 1);
    setIouList([...iouList]);
  }

  const changeIouDocument = (iouIndex, documentIndex, value) => {
    let iou = iouList[iouIndex];
    iou.request_invoice_documents[documentIndex] = value;
    setIouList([...iouList]);
  }

  const addIouAttachment = (iouIndex) => {
    let iou = iouList[iouIndex];
    iou.request_invoice_attachments = [...iou.request_invoice_attachments, {
      "name": '',
      "status": 'Ada & Terlampir',
      "files": null,
      "loading": false,
    }];
    setIouList([...iouList]);
  }

  const removeIouAttachment = (iouIndex, attachmentIndex) => {
    const iou = iouList[iouIndex];
    iou.request_invoice_attachments.splice(attachmentIndex, 1);
    setIouList([...iouList]);
  }

  const changeIouAttachmentData = (iouIndex, attachmentIndex, column, value) => {
    let iou = iouList[iouIndex];
    iou.request_invoice_attachments[attachmentIndex][column] = value;
    if (column === 'files') {
      iou.request_invoice_attachments[attachmentIndex].loading = false;
    }
    setIouList([...iouList]);
  }

  const uploadAttachments = async (iouIndex, attachmentIndex, files) => {
    changeIouAttachmentData(iouIndex, attachmentIndex, 'loading', true);
    const formData = new FormData();
    files.forEach((attachment) => {
      formData.append('files', attachment);
    });
    try {
      const responseUploadAttachments = await jwtFetch(config.ENDPOINT + 'upload/gdrive', {
        method: 'POST',
        body: formData,
      });
      if (!responseUploadAttachments.ok) {
        throw new Error(`Upload failed with status: ${responseUploadAttachments.status}`);
      }
      const resultUploadAttachments = await responseUploadAttachments.json();
      if (resultUploadAttachments.status === 200) {
        changeIouAttachmentData(iouIndex, attachmentIndex, 'files', resultUploadAttachments.data);
      } else {
        alert(`Upload error: ${resultUploadAttachments.message}`);
      }
    } catch (error) {
      alert(`Upload error: ${error.message || error}`);
    } finally {
      changeIouAttachmentData('loading', false, iouIndex, attachmentIndex);
    }
  }

  const updateAtb = async (status) => {
    try {
      setIsLoadingSubmit(true);
      let isBundle = false;
      let ious = iouList;
      for (let iouIndex in ious) {
        let iouSubtotal = 0;
        for (let iouItemIndex in ious[iouIndex].iou_items) {
          if (ious[iouIndex].iou_items[iouItemIndex].product_type === 'Bundle') {
            isBundle = true;
          }
          ious[iouIndex].iou_items[iouItemIndex].product_active_licence_date = format(new Date(ious[iouIndex].iou_items[iouItemIndex].product_active_licence_date), 'yyyy-MM-dd');
          if (ious[iouIndex].iou_items[iouItemIndex].action === 'Delete') {
            ious[iouIndex].iou_items[iouItemIndex].action = 'Update';
          }
          iouSubtotal += parseFloat((parseFloat(ious[iouIndex].iou_items[iouItemIndex].product_grand_total || 0)).toFixed(3));
        }
        ious[iouIndex].iou_exchange_rate = exchangeRate;
        ious[iouIndex].iou_subtotal = iouSubtotal;
        ious[iouIndex].iou_total = iouSubtotal;
        ious[iouIndex].iou_tax_price = parseFloat((iouSubtotal * ious[iouIndex].iou_tax_rate / 100).toFixed(3));
        ious[iouIndex].iou_grand_total = parseFloat((iouSubtotal + ious[iouIndex].iou_tax_price).toFixed(3));
        ious[iouIndex].start_term_period = format(ious[iouIndex].start_term_period, 'yyyy-MM-dd');
        ious[iouIndex].end_term_period = format(ious[iouIndex].end_term_period, 'yyyy-MM-dd');
        ious[iouIndex].created_on = format(ious[iouIndex].created_on, 'yyyy-MM-dd HH:mm:ss');
        ious[iouIndex].request_invoice_documents = JSON.stringify(ious[iouIndex].request_invoice_documents);
        ious[iouIndex].request_invoice_attachments = JSON.stringify(ious[iouIndex].request_invoice_attachments);
        ious[iouIndex].request_invoice_attachments = JSON.stringify(ious[iouIndex].request_invoice_attachments);
      }

      if (isBundle === false) {
        const isValid = validateQuantities();
        if (isValid.status === false) {
          alert(isValid.message);
          return;
        }
      }

      const fetchUpdateAtb = await jwtFetch(config.ENDPOINT + 'update/atb', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(ious)
      });
      const responseUpdateAtb = await fetchUpdateAtb.json();
      if (responseUpdateAtb.status === 200) {
        window.location.href = '/quotation/atb/detail/' + id_quotation + '/' + term_number;
      } else {
        alert(responseUpdateAtb.message);
      }
    } catch (error) {
      console.error('Error in updateAtb:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  const sendAtb = async (status) => {
    try {
      setIsLoadingSubmit(true);
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));
      let ious = iouList;
      for (let iouIndex in ious) {
        const requestEditIouStatus = {
          id_iou: ious[iouIndex].id_iou,
          iou_status: status,
          updated_on: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
          updated_by: crmUser.user_keyid,
        };

        requestEditIouStatus.request_invoice_date = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
        requestEditIouStatus.request_invoice_by = crmUser.user_keyid;
        requestEditIouStatus.request_invoice_remarks = ious[iouIndex].request_invoice_remarks;

        await jwtFetch(config.ENDPOINT + 'update/iou_status', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestEditIouStatus)
        });
      }
      window.location.href = '/quotation/atb/detail/' + id_quotation + '/' + term_number;
    } catch (error) {
      console.error('Error in sendAtb:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="quotation-atb-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="quotation" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                {quotation && salesOrder && iouList && (() => {
                  const isUpcoming = (new Date(iouList[0].start_term_period) >= new Date()) && (new Date(iouList[0].start_term_period) <= addDays(new Date(), 7));
                  const isOverdue = new Date(iouList[0].start_term_period) <= new Date();
                  return (
                    <section className="mb-4">
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                          <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Invoice Request {crmUser.user_department === 'Sales' ? 'Detail' : 'Validation'}</div>
                          {iouList[0].iou_status === 'New' && (
                            <span className="badge badge-sm ms-3 bg-secondary text-light">Not Billed</span>
                          )}
                          {iouList[0].iou_status === 'New' && isUpcoming && (
                            <span className="badge badge-sm bg-warning text-light ms-2">Upcoming</span>
                          )}
                          {iouList[0].iou_status === 'New' && isOverdue && (
                            <span className="badge badge-sm bg-danger text-light ms-2">Overdue</span>
                          )}
                          {iouList[0].iou_status === 'In Progress' && (
                            <span className="badge badge-sm ms-3 bg-warning text-dark">Admin Validation</span>
                          )}
                          {iouList[0].iou_status === 'Notification Sent' && (
                            <span className="badge badge-sm ms-3 bg-info text-dark">Requested to Finance</span>
                          )}
                        </div>
                        <div className="d-flex align-items-center justify-content-between gap-2">
                          {crmUser.user_level !== 'View' && (
                            <button className="btn btn-sm btn-outline-secondary" onClick={() => window.location.href = '/quotation/atb/' + iouList[0].quotation_id + '/' + iouList[0].term_number}><i className="bi bi-pencil" /> Edit</button>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Company Group</div>
                            <div className="col-md-8">{quotation.company_name} <a href={`/client/detail/${quotation.company_id}`}><i className="bi bi-link-45deg" /></a></div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Currency</div>
                            <div className="col-md-8">{iouList[0].iou_currency}</div>
                          </div>
                          <div className="row align-items-baseline mb-2">
                            <div className="col-md-4 text-secondary">Exchange Rate</div>
                            <div className="col-md-8">1 USD <i className="bi bi-arrow-right mx-1" /> {priceFormat(exchangeRate, iouList[0].iou_currency)} ({quotation && quotation.quotation_exchange_floating})</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Schedule</div>
                            <div className="col-md-8">{term_number.replace('Term', 'Schedule')}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Period Date</div>
                            <div className="col-md-8">{iouList[0].start_term_period === iouList[0].end_term_period ? format(iouList[0].start_term_period, 'd MMM yyyy') : (format(iouList[0].start_term_period, 'd MMM yyyy') + " - " + format(iouList[0].end_term_period, 'd MMM yyyy'))}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Order Type</div>
                            <div className="col-md-8">{quotation.quotation_item_list[0].service_type}</div>
                          </div>
                          <div className="row mb-4">
                            <div className="col-md-4 text-secondary">Sales Name</div>
                            <div className="col-md-8">{iouList[0].sales_name}</div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-4 text-secondary">Admin Name</div>
                            <div className="col-md-8">{iouList[0].atb_name}</div>
                          </div>
                          {/* {quotation.quotation_exchange_floating === 'Floating' ? (
                            <div className="row align-items-baseline mb-2">
                              <div className="col-md-4 text-secondary">Exchange Rate <span className="text-danger">*</span></div>
                              <div className="col-md-4">
                                <div className="input-group mb-1">
                                  <input className="form-control text-end" type="text" value={1} disabled required/>
                                  <span className="input-group-text">USD</span>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="input-group mb-1">
                                  <input className="form-control text-end" type="text" value={priceFormat(exchangeRate)} onChange={(e) => setExchangeRate(numberFormat(e.target.value))} required/>
                                  <span className="input-group-text">{iouList[0].iou_currency}</span>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="row align-items-baseline mb-2">
                              <div className="col-md-4 text-secondary">Exchange Rate <span className="text-danger">*</span></div>
                              <div className="col-md-8">1 USD <i className="bi bi-arrow-right mx-1"/> {priceFormat(exchangeRate, iouList[0].iou_currency)} ({quotation && quotation.quotation_exchange_floating})</div>
                            </div>
                          )} */}
                        </div>
                        <div className="col-md-6">
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fs-14 mb-0"><strong>Quotation</strong></p>
                                <a href={"/quotation/detail/" + quotation.id_quotation}>{quotation.quotation_code} <i className="bi bi-link-45deg ms-1" /></a>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fs-14 mb-0"><strong>Sales Order</strong></p>
                                <a href={"/salesorder/detail/" + salesOrder.id_so}>{salesOrder.so_code} <i className="bi bi-link-45deg ms-1" /></a>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between mb-2">
                                <p className="fs-14 mb-0"><strong>Cost &amp; Profit Summary</strong></p>
                              </div>
                              <div className="p-2">
                                <div className="row">
                                  <div className="col-md-6 text-secondary">Total Cost</div>
                                  <div className="col-md-6 text-end">{priceFormat(quotation.quotation_cost, quotation.quotation_currency)}</div>
                                </div>
                                <hr />
                                <div className="row mb-2">
                                  <div className="col-md-6 text-secondary">Subtotal Sell (Pre-Discount, Pre-Tax)</div>
                                  <div className="col-md-6 text-end">{priceFormat(quotation.quotation_subtotal, quotation.quotation_currency)}</div>
                                </div>
                                <div className="row mb-2">
                                  <div className="col-md-6 text-secondary">Discount on QT {quotation.quotation_discount_price > 0 ? (" (" + priceFormat(quotation.quotation_discount_rate) + "%)") : ""}</div>
                                  <div className="col-md-6 text-end"><span className="text-danger">{quotation.quotation_discount_price > 0 ? ("-" + priceFormat(quotation.quotation_discount_price, quotation.quotation_currency)) : "0"}</span></div>
                                </div>
                                <div className="row">
                                  <div className="col-md-6 text-secondary">Net Amount Before Tax</div>
                                  <div className="col-md-6 text-end">{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</div>
                                </div>
                                <hr />
                                <div className="row">
                                  <div className="col-md-6 text-secondary">Estimated  Gross Profit <strong>{" (" + quotation.quotation_margin_rate + "%)"}</strong></div>
                                  <div className="col-md-6 text-end">{priceFormat(quotation.quotation_margin_price, quotation.quotation_currency)}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="row">
                        <div className="col-md-12">
                          <div className="row align-items-baseline mb-2">
                            <div className="col-md-2 text-secondary">SKU List</div>
                            <div className="col-md-10">
                              <div className="table-responsive">
                                <table className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      <th className="bg-secondary text-light" style={{textAlign: 'center', width: '50px'}}>#</th>
                                      <th className="bg-secondary text-light">SKUs</th>
                                      <th className="bg-secondary text-light" style={{textAlign: 'center'}}>Qty</th>
                                      <th className="bg-secondary text-light" style={{textAlign: 'center'}}>Period</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[...quotationItems].sort((a, b) => b.id_quotation_item - a.id_quotation_item).map((quotationItem, qi) =>(
                                      <tr key={'quotation-item-' + qi}>
                                        <td align="center">{qi + 1}</td>
                                        <td>{quotationItem.product_display_name}</td>
                                        <td align="center">{quotationItem.product_qty + ' Unit(s)'}</td>
                                        <td align="center">{quotationItem.contract_long_period + ' Month(s)'}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </section>
                  )
                })()}

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24">Subsidiary List</div>
                  </div>
                  {iouList ? iouList.map((iou, i) =>
                    <div className={"card mb-4"} key={"iou-" + i}>
                      <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="fs-16"><strong>Subsidiary #{i + 1}</strong></div>
                          <div className="d-flex align-items-center gap-2">
                            {crmUser.user_level !== 'View' && (
                              <a className="btn btn-sm btn-outline-secondary" href={'/client/subsidiary/edit/' + iou.subcompany_id} target="_blank" rel="noopener noreferrer"><i className="bi bi-pencil me-2" /> Edit Subsidiary</a>
                            )}
                          </div>
                        </div>
                        <div className="card mb-4">
                          <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <div className="fs-14"><strong>{iou.subcompany.company_billing_name}</strong></div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-2 text-secondary">Legal Name</div>
                              <div className="col-md-10">{iou.subcompany.company_billing_name}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-2 text-secondary">Billing Address</div>
                              <div className="col-md-10">{iou.subcompany.company_billing_address}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-2 text-secondary">Mailing Address</div>
                              <div className="col-md-10">{iou.subcompany.company_address}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-2 text-secondary">Phone Number</div>
                              <div className="col-md-10">{iou.subcompany.company_phone}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-2 text-secondary">Fax Number</div>
                              <div className="col-md-10">{iou.subcompany.company_fax}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-md-2 text-secondary">NPWP Number</div>
                              <div className="col-md-10">{iou.subcompany.company_npwp_number}</div>
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-baseline mb-3">
                          <div className="col-md-2 text-secondary">SKUs</div>
                          <div className="col-md-10">
                            <div className="table-responsive">
                              <table className="table table-hover bordered mb-0">
                                <thead>
                                  <tr>
                                    <th className="bg-gold w-30">#</th>
                                    <th className="bg-gold text-start">SKUs</th>
                                    <th className="bg-gold w-85">Qty</th>
                                    <th className="bg-gold w-105">Period</th>
                                    <th className="bg-gold w-105">Amount</th>
                                    {/* <th className="bg-gold w-30"></th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {iou.iou_items.map((iouItem, p) =>
                                    <tr className={iouItem.action === 'Delete' ? 'd-none' : ''} key={"iou-" + i + "-item-" + p}>
                                      <td valign="middle" align="center">{p + 1}</td>
                                      <td valign="middle">
                                        {iouItem.product_name}
                                        {/* <select className="form-select" value={iouItem.product_id} onChange={(e) => changeIouItemProduct(i, p, e.target.value)} required>
                                          <option value=""></option>
                                          {quotationItems && [...quotationItems].sort((a, b) => a.product_display_name.localeCompare(b.product_display_name)).map((item, i) =>
                                            <option key={"item-" + i} value={item.product_id ? item.product_id : item.product_display_name}>{item.product_display_name}</option>
                                          )}
                                        </select> */}
                                      </td>
                                      <td align="center" valign="middle">{priceFormat(iouItem.product_qty)} Unit(s)
                                        {/* <input className="form-control text-end" type="number" value={priceFormat(iouItem.product_qty)} onChange={(e) => changeIouItemQty(i, p, e.target.value)} required/> */}
                                      </td>
                                      <td align="center" valign="middle">{iouItem.contract_long_period} Month(s)</td>
                                      <td align="right" valign="middle">
                                        {priceFormat(iouItem.product_grand_total, iouItem.product_currency)}
                                        <div className="d-none">
                                          <div className="d-flex justify-content-between"><span>product_cost_original:</span><span>{priceFormat(iouItem.product_cost_original)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_cost:</span><span>{priceFormat(iouItem.product_cost)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_price_original:</span><span>{priceFormat(iouItem.product_price_original)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_price:</span><span>{priceFormat(iouItem.product_price)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_subtotal:</span><span>{priceFormat(iouItem.product_subtotal)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_discount_price:</span><span>{priceFormat(iouItem.product_discount_price)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_discount_rate:</span><span>{priceFormat(iouItem.product_discount_rate)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_total:</span><span>{priceFormat(iouItem.product_total)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_total_prorate:</span><span>{priceFormat(iouItem.product_total_prorate)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_discount_prorate:</span><span>{priceFormat(iouItem.product_discount_prorate)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_grand_total:</span><span>{priceFormat(iouItem.product_grand_total)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_margin_price:</span><span>{priceFormat(iouItem.product_margin_price)}</span></div>
                                          <div className="d-flex justify-content-between"><span>product_margin_rate:</span><span>{priceFormat(iouItem.product_margin_rate)}</span></div>
                                          <div className="d-flex justify-content-between"><span>contract_long_period:</span><span>{priceFormat(iouItem.contract_long_period)}</span></div>
                                          <div className="d-flex justify-content-between"><span>action:</span><span>{iouItem.action}</span></div>
                                        </div>
                                      </td>
                                      {/* <td align="center" valign="middle">
                                        <button className="btn btn-link text-danger" type="button" onClick={() => removeIouItemProduct(i, p)}><i className="bi bi-trash"/></button>
                                      </td> */}
                                    </tr>
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    {/* <td className="ps-0" colSpan={2}>
                                      <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => addIouItemProduct(i)}><i className="bi bi-plus-lg me-2"/> SKU</button>
                                    </td>
                                    <td colSpan={2} align="right">Total</td> */}
                                    <td colSpan={4} align="right">Total</td>
                                    <td align="right"><strong>{priceFormat(iou.iou_items.reduce((sum, iouItem) => sum + parseFloat(iouItem.product_grand_total), 0), iou.iou_currency)}</strong></td>
                                    {/* <td align="right"></td> */}
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-baseline mb-3">
                          <div className="col-md-2 text-secondary">Billing Documents</div>
                          <div className="col-md-10">
                            <div className="table-responsive">
                              <table className="table table-hover bordered mb-0">
                                <thead>
                                  <tr>
                                    <th className="bg-gold w-30">#</th>
                                    <th className="bg-gold text-start">Title</th>
                                    {/* <th className="bg-gold w-30"></th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {iou.request_invoice_documents && Array.isArray(iou.request_invoice_documents) && iou.request_invoice_documents.length > 0 && iou.request_invoice_documents.map((document, d) =>
                                    <tr key={"iou-" + i + "-document-" + d}>
                                      <td valign="middle" align="center">{d + 1}</td>
                                      <td valign="middle">{document}
                                        {/* <input className="form-control" type="text" value={document} onChange={(e) => changeIouDocument(i, d, e.target.value)}/> */}
                                      </td>
                                      {/* <td align="center" valign="middle">
                                        <button className="btn btn-link text-danger" type="button" onClick={() => removeIouDocument(i, d)}><i className="bi bi-trash"/></button>
                                      </td> */}
                                    </tr>
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td className="ps-0" colSpan={3}>
                                      {/* <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => addIouDocument(i)}><i className="bi bi-plus-lg me-2"/> Document</button> */}
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-baseline mb-3">
                          <div className="col-md-2 text-secondary">Attached Transaction Reference</div>
                          <div className="col-md-10">
                            <div className="table-responsive">
                              <table className="table table-hover bordered mb-0">
                                <thead>
                                  <tr>
                                    <th className="bg-gold w-30">#</th>
                                    <th className="bg-gold text-start">Title</th>
                                    <th className="bg-gold w-150">Status</th>
                                    <th className="bg-gold">File</th>
                                    {/* <th className="bg-gold w-30"></th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {iou.request_invoice_attachments && Array.isArray(iou.request_invoice_attachments) && iou.request_invoice_attachments.length > 0 && iou.request_invoice_attachments.map((attachment, a) =>
                                    <tr key={"iou-" + i + "-attachment-" + a}>
                                      <td valign="middle" align="center">{a + 1}</td>
                                      <td valign="middle">{attachment.name}
                                        {/* <input className="form-control" type="text" value={attachment.name} onChange={(e) => changeIouAttachmentData(i, a, 'name', e.target.value)} required/> */}
                                      </td>
                                      <td valign="middle">{attachment.status}
                                        {/* <select className="form-select" value={attachment.status} onChange={(e) => changeIouAttachmentData(i, a, 'status', e.target.value)} required>
                                          <option value="Ada & Terlampir">Ada &amp; Terlampir</option>
                                          <option value="Ada & Tidak Terlampir">Ada &amp; Tidak Terlampir</option>
                                          <option value="Tidak Ada">Tidak Ada</option>
                                          <option value="Dalam Proses">Dalam Proses</option>
                                        </select> */}
                                      </td>
                                      <td valign="middle">
                                        {attachment.loading === false ? (
                                          <div>
                                            {attachment.files ? (
                                              <a className="ellipsis" href={attachment.files[0].fileUrl} target="_blank" rel="noopener noreferrer">{shortenUrl(attachment.files[0].fileUrl, 50)} <i className="bi bi-link-45deg ms-2" /></a>
                                            ) : (
                                              crmUser.user_level !== 'View' && (
                                                <input className="form-control" type="file" accept=".pdf, .png, .jpg, .jpeg, .gif, .webp, .svg, .bmp, .avif, .csv, .xls, .xlsx" onChange={(e) => uploadAttachments(i, a, Array.from(e.target.files))} required />
                                              )
                                            )}
                                          </div>
                                        ) : 'Loading...'}
                                      </td>
                                      {/* <td align="center" valign="middle">
                                        <button className="btn btn-link text-danger" type="button" onClick={() => removeIouAttachment(i, a)}><i className="bi bi-trash"/></button>
                                      </td> */}
                                    </tr>
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td className="ps-0" colSpan={5}>
                                      {/* <button className="btn btn-sm btn-outline-secondary" type="button" onClick={() => addIouAttachment(i)}><i className="bi bi-plus-lg me-2"/> Attachment</button> */}
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-2 text-secondary">Quotation Remarks</div>
                          <div className="col-md-10">{iou.quotation_remarks}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-2 text-secondary">Sales Order Remarks</div>
                          <div className="col-md-10">{iou.so_remarks}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-2 text-secondary">Additional Notes</div>
                          <div className="col-md-10">{iou.request_invoice_remarks}
                            {/* <textarea className="form-control" rows="4" value={iou.request_invoice_remarks ? iou.request_invoice_remarks : ''} onChange={(e) => changeIouData(i, 'request_invoice_remarks', e.target.value)}/> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (<p>No Account data</p>)}
                </section>

                <section className="mb-4">
                  {iouList && (
                    <div className="d-flex align-items-center justify-content-end gap-2">
                      {(iouList[0].iou_status === 'New' && crmUser.user_department === 'Sales') && (
                        <button className="btn btn-outline-primary" onClick={() => sendAtb('In Progress')} disabled={isLoadingSubmit}>Send to Sales Admin</button>
                      )}
                      {(iouList[0].iou_status === 'In Progress' && crmUser.user_department === 'Sales Admin') && (
                        <button className="btn btn-outline-primary" onClick={() => sendAtb('Notification Sent')} disabled={isLoadingSubmit}>Send to Finance</button>
                      )}
                    </div>
                  )}
                </section>

                {/* <section className="mb-4">
                  {quotation && (
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <Select className="w-400" value={subcompanyId} options={subcompanyList && subcompanyList.map(subcompany => ({ value: subcompany.id_subcompany, label: subcompany.company_name }))} onChange={(value) => setSubcompanyId(value)} placeholder="Select Subsidiary..." required />
                        <button className="btn btn-outline-secondary ms-2" type="button" onClick={() => addIou()}><i className="bi bi-plus-lg me-2"/> Subsidiary</button>
                      </div>
                      <div className="d-flex align-items-center justify-content-end">
                        <button className="btn btn-link" type="button" onClick={() => window.location.href = '/quotation/detail/' + id_quotation} disabled={isLoadingSubmit}>Cancel</button>
                        <button className="btn btn-outline-primary" type="button" onClick={() => updateAtb()} disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                      </div>
                    </div>
                  )}
                </section> */}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationAtbDetail;


